import {defineNuxtPlugin, useRuntimeConfig} from 'nuxt/app';
import Cookie from 'cookie-universal';
import {applicationContext} from '@@/package/application/applicationContext';
import {resolveRuntimeConfig} from '@@/package/config/resolveConfig';

export default defineNuxtPlugin(nuxtApp => {
    // On the client, pick the config that matches the hostname so a single build
    // artifact serves stage / opt-global / opt-eu / opt-kr correctly. On the server
    // (SSR pre-render) we fall back to the build-time default (`live`).
    const defaultConfig = useRuntimeConfig().public;
    let resolvedConfig = (typeof window !== 'undefined')
        ? resolveRuntimeConfig(window.location.hostname)
        : defaultConfig;

    // `local` run-type's API_URL (`/__api`) is relative on purpose -- the browser resolves it
    // against its own origin to reach the dev-only same-origin proxy (server/routes/__api).
    // Node's axios has no implicit origin during SSR, so a relative baseURL fails outright
    // (every SSR-fetched page, e.g. /home/events/:eventId, 404s regardless of locale prefix).
    // Make it absolute using the current request's own origin, which points back at this
    // same dev server and its proxy. `defaultConfig` comes from `useRuntimeConfig()`, which is
    // shared across requests in the same Nitro process, so build a new object rather than
    // mutating it -- otherwise one request's origin would leak into every later request.
    if (typeof window === 'undefined' && resolvedConfig.API_URL?.startsWith('/')) {
        const requestOrigin = useRequestURL().origin;
        resolvedConfig = { ...resolvedConfig, API_URL: `${requestOrigin}${resolvedConfig.API_URL}` };
    }

    // @ts-ignore
    applicationContext.setConfig(resolvedConfig);

    // setCookie
    applicationContext.setCookies(Cookie());

    // setService
    applicationContext.setServices();

    // global provide
    return {
        provide: {
            container: applicationContext
        }
    };
});
